import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import { authChildren } from './authChildren';
import { contactsChildren } from './contactsChildren';
import { coursesChildren } from './coursesChildren';
import { donationsChildren } from './donationsChildren';
import { userManagementChildren } from '@/router/userManagementChildren';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/auth',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "auth" */ '../components/layouts/auth-layout/AuthLayout.vue'),
    children: authChildren
  },
  {
    path: '/',
    component: (): Promise<typeof import('vue')> =>
      import(/* webpackChunkName: "main" */ '../components/layouts/main-layout/MainLayout.vue'),
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: (): Promise<typeof import('vue')> => import(/* webpackChunkName: "main" */ '../views/Dashboard.vue')
      },
      {
        path: 'contacts',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue'),
        children: contactsChildren
      },
      {
        path: 'bookings',
        name: 'bookings',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../views/bookings/Bookings.vue')
      },
      {
        path: 'courses',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue'),
        children: coursesChildren
      },
      {
        path: 'donations',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue'),
        children: donationsChildren
      },
      {
        path: 'settings',
        name: 'settings',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../views/settings/Settings.vue')
      },
      {
        path: 'user-management',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../components/shared/pass-through/PassThrough.vue'),
        children: userManagementChildren
      },
      {
        path: 'my-account',
        name: 'my-account',
        component: (): Promise<typeof import('vue')> =>
          import(/* webpackChunkName: "main" */ '../views/my-account/MyAccount.vue')
      },
      {
        path: '',
        redirect: {
          name: 'dashboard'
        }
      },
      {
        path: 'page-not-found',
        name: '404',
        component: (): Promise<typeof import('vue')> => import(/* webpackChunkName: "main" */ '../views/NotFound.vue')
      },
      {
        path: '**',
        redirect: {
          name: '404'
        }
      }
    ]
  }
];

const router: VueRouter = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;
